import Button from '@shared/components/Button/Button';

interface SecurityCodeModalFooterProps {
  onCancel: () => void;
  cancelLabel: string;
  onConfirm: () => void;
  confirmLabel: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  confirmTestId?: string;
}

const SecurityCodeModalFooter = ({
  onCancel,
  cancelLabel,
  onConfirm,
  confirmLabel,
  isLoading,
  isDisabled,
  confirmTestId,
}: SecurityCodeModalFooterProps) => (
  <>
    <Button
      variant="secondaryTertiary"
      size="md"
      className="h-[47px] w-full min-w-0 rounded-2xl px-6 sm:w-fit sm:min-w-[105px]"
      onClick={onCancel}
    >
      {cancelLabel}
    </Button>
    <Button
      variant="primary"
      size="md"
      className="h-12 w-full min-w-0 rounded-2xl px-6 sm:w-fit sm:min-w-[157px]"
      onClick={onConfirm}
      loading={isLoading}
      disabled={isDisabled}
      data-testid={confirmTestId}
    >
      {confirmLabel}
    </Button>
  </>
);

export default SecurityCodeModalFooter;
